module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_home_member", [["div",{"id":"welcome"},[["div",{"class":"fleft"},[["span",{},[["textNode",{"text":"Welcome back,"}]]],["textNode",{"text":" "}],["span",{"class":"username"},[["span",{},[],[["login","__text",true,[],"member"]]]]]]],["div",{"class":"fleft favorites"},[["a",{"href":"/favorites"},[["textNode",{"text":"Favorites"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/layout/home/member.tpl
// module id = 1174
// module chunks = 4